import { ObjToQueryString } from '../utils/Utils';
import { getRequest, HandlerResponse } from './api';

export const getOutboundManifestByAwbNoAPI = async (queryParams?: any): Promise<any> => {
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${process.env.REACT_APP_API_ENDPOINT}/manifest/get-outbound-manifest-by-awbNo${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};